import { INTENT_TYPE } from '../../constants';
import { type ConvergenceRule, type FeatureContext } from '../types';

/**
 * `S-INPUT-LIMIT` (priority 1100) — oversized input locks Search.
 *
 * The second hard preflight. Both bounds are product limits rather than engine
 * failures: a 5,000-character paste is a legitimate thing for a user to do, and the
 * right answer is to run Search rather than to spend the input-handler budget
 * segmenting it or to send it to a classifier.
 *
 * Both bounds are cheap by construction. The code-point check is a capped scan with an
 * O(1) fast path, and it is consulted first — so an oversized paste is rejected without
 * being segmented at all. Segmentation, when it does run, stops at the 513th token.
 *
 * A committed decision here also suppresses model work, which the harness reports
 * as `INPUT_LIMIT_REACHED`.
 */
export const exceedsInputLimit = (features: FeatureContext): boolean =>
	features.exceedsCodePointLimit || features.exceededWordTokenCap;

export const inputLimitRule: ConvergenceRule = {
	type: INTENT_TYPE.FPS,
	pattern: 'INPUT_LIMIT',
	matches: exceedsInputLimit,
};
